import { Menu, Tooltip } from '@mantine/core';
import { SignatureSingleActionProps } from 'components/tables/data/signature/types';
import { Link } from 'react-router-dom';
import { IconEye } from '@tabler/icons-react';
import { SIGNATURE_PAGE_PATH } from 'routes/paths';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * View action for signatures.
 */
export default function ViewAction({ signature, kind }: SignatureSingleActionProps) {
  // Use the first revision ID to view
  const firstRevisionId = signature.revisions[0]?.revisionId;
  const link = SIGNATURE_PAGE_PATH.insert({ kepMessageUuid: signature.kepMessageUuid });

  if (!firstRevisionId) {
    return null;
  }

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Pozrieť" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="secondary" size="md" component={Link} to={link}>
          <IconEye />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button size="md" component={Link} to={link} leftIcon={<IconEye />} variant="secondary" w={128}>
        Pozrieť
      </Button>
    );
  }

  return (
    <Menu.Item component={Link} to={link} icon={<IconEye stroke="1.5" size={24} />} color="gray.8">
      Pozrieť
    </Menu.Item>
  );
}
